<template>
<div style="margin-bottom: 100px">
    <vue-headful title="Languages" />
    <v-container fluid style="background-color: #f5f5f5;" :class="{ 'px-1': $vuetify.breakpoint.smAndDown, 'pt-3': true}">
        <!--data table-->
        <v-card tile flat class="mx-1">
            <im-table-header :items="im_header" />
        </v-card>
        <!--./ data table -->
        <div class="mx-1" style="position: relative; height: 3px">
            <v-progress-linear v-if="loading" indeterminate height="3" class="pa-0 ma-0" color="primary" style="position: absolute" />
        </div>
        <!-- DATATABLE ROWS -->
        <v-card tile flat style="background-color: transparent !important;" class="mx-1">
            <v-data-iterator :items="items" :page.sync="page" :items-per-page.sync="size" :server-items-length="total" :footer-props="{ itemsPerPageOptions }">
                <template v-slot:default="props">
                    <v-row v-for="item in props.items" class="im-result" no-gutters :key="item.id" @click="openEdit(item)">
                        <div class="pa-2" style="width: 5%">{{ item.id}}</div>
                        <div class="pa-2" style="width: 25%">{{ item.name}}</div>
                        <div class="pa-2" style="width: 25%">{{ item.code}}</div>
                        <div class="pa-2" style="width: 45%"></div>
                    </v-row>
                </template>
                <template v-slot:no-data>
                    <v-alert :value="true" type="info" color="primary">
                        No data available.
                    </v-alert>
                </template>
            </v-data-iterator>
        </v-card>
    </v-container>

    <!-- add button -->
    <v-btn color="primary" @click="openCreate()" fab large fixed bottom right>
        <v-icon>add</v-icon>
    </v-btn>
    <!-- ./ add button -->

    <!-- add dialog  -->
    <v-dialog v-model="add_dialog" max-width="920" :fullscreen="$vuetify.breakpoint.smAndDown">
        <v-card flat tile color="primary">
            <v-card-title class="important white--text" height="50">
                Languages
            </v-card-title>

            <v-container fluid style="background-color: #f5f5f5;" :class="{ 'px-0': $vuetify.breakpoint.smAndDown, 'pt-3': true}">
                <v-row no-gutters>

                    <v-col cols="12" md="6" class="px-1 py-1">
                        <v-card class="elevation-1 my-1 pa-1">
                            <div class="detail font-weight-bold pa-0 ma-0">Name</div>
                            <v-text-field v-model="item.name" class="im-select ma-0" solo flat clearable placeholder="Enter name for language" hide-details />
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="6" class="px-1 py-1">
                        <v-card class="elevation-1 my-1 pa-1">
                            <div class="detail font-weight-bold pa-0 ma-0">Code</div>
                            <v-text-field v-model="item.code" class="im-select ma-0" solo flat clearable placeholder="Enter code for language" hide-details />
                        </v-card>
                    </v-col>
                </v-row>
                <v-card-actions>
                    <v-btn v-if="edit" color="red" @click="openDeleteModal()">Delete</v-btn>
                    <v-spacer />
                    <v-btn color="primary" text @click="exitAddDialog()">Cancel</v-btn>
                    <v-btn color="primary" :loading="is_saving" :disabled="is_saving" @click="saveItem()">Submit</v-btn>
                </v-card-actions>
            </v-container>
        </v-card>
    </v-dialog>
    <!-- ./ add dialog-->
    <!--delete dialog-->
    <v-dialog v-model="delete_dialog" max-width="320">
        <v-card>
            <v-card-text>
                Are you sure you want to delete this language?
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn dark color="red" @click="destroy()">
                    Delete
                </v-btn>
                <v-btn color="primary" text @click="delete_dialog=false">
                    Cancel
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!--./delete dialog -->
</div>
</template>

<script>
import {
    mapActions
} from 'vuex'
import defaults from "../components/utils/PropDefaults.js"
import IMTableHeader from '../components/utils/IMTableHeader.vue';

export default {

    name: `ratings`,

    components: {
        'im-table-header': IMTableHeader,
    },

    data() {
        return {
            language: null,

            // dialogs
            delete_dialog: false,
            add_dialog: false,
            item: {},
            edit: false,

            // table items
            items: [],
            im_header: [
                {
                    text: "Id",
                    sortable: false,
                    align: "left",
                    width: "5%"
                }, {
                    text: "Name",
                    sortable: false,
                    align: "left",
                    width: "25%"
                }, {
                    text: "Code",
                    sortable: false,
                    align: "left",
                    width: "25%"
                }
            ],

            // table attributes
            loading: null,
            is_saving: null,
            total: 0,
            pagination: null,
            rppi: [10, 25, 50, 100],
            total: 0,
            page: 1,
            size: 10,
            itemsPerPageOptions: [10, 50, 100],


        }
    },

    watch: {

        page: {
            handler() {
                this.getItems()
            }
        },
        size: {
            handler() {
                this.getItems()
            }
        },
    },

    created() {
        this.getItems()
    },


    methods: {
        ...mapActions('alert', ['success', 'error']),

        getItems() {
            // we are currently loading
            this.loading = true;

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/translations/languages';

            this.$axios.get(endpoint)
                .then(response => {
                    this.items = response.data.data;
                    this.total = response.data.pagination.total;
                })
                .catch(error => {
                    console.log(error);
                    this.error('Oops, something went wrong!');
                })
                .finally(() => {
                    this.loading = false;
                })
        },

        saveItem() {
            this.is_saving = false;

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/translations/languages';


            // call update or save endpoints
            if(this.item.id) {
                this.$axios.put(endpoint + '/' + this.item.id, this.item) // eslint-disable-next-line
                    .then(response => {
                        this.getItems();
                        this.success('Language updated.');
                        this.exitAddDialog();
                    })
                    .catch(error => {
                        console.error(error);
                        this.error('Oops, something went wrong!');
                    })
                    .finally(() => {
                        this.is_saving = false;
                    });

            } else {
                this.$axios.post(endpoint, this.item) // eslint-disable-next-line
                    .then(response => {
                        this.getItems();
                        this.success('Language created.');
                        this.exitAddDialog();
                    })
                    .catch(error => {
                        console.log(error);
                        this.error('Oops, something went wrong!');
                    })
                    .finally(() => {
                        this.is_saving = false;
                    });

            }
        },

        exitAddDialog() {
            this.edit = false;
            this.item = {};
            this.add_dialog = false;
        },

        openCreate() {
            this.rating = defaults.rating_item;
            this.add_dialog = true;
        },

        openEdit(value) {
            this.edit = true;
            this.item = this.$clone(value);
            this.add_dialog = true;
        },

        destroy() {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/translations/languages';

            // call delete endpoint

            this.$axios.delete(endpoint + '/' + this.item.id) // eslint-disable-next-line
                .then(response => {
                    this.getItems();
                    this.success('Language deleted.');
                    this.exitAddDialog();
                    this.delete_dialog = false;
                })
                .catch(error => {
                    console.error(error);
                    this.error('Oops, something went wrong!');
                })
                .finally(() => {});
        },

        openDeleteModal() {
            this.delete_dialog = true;
        },

    }

}
</script>
